module.exports = __webpack_public_path__ + "img/car-circle-bolt.37fe605d.svg";